/**
 * 메일 API: 이메일 인증 관련 API
 */

import { publicClient } from "@/shared/api/public-client";

interface SendEmailRequest {
  email: string;
  username: string;
  code: string;
}

class MailAPI {
  /**
   * 이메일 인증 코드 발송
   * @param sendEmailInfo 이메일, 사용자명, 인증코드
   */
  async sendVerificationEmail(sendEmailInfo: SendEmailRequest): Promise<void> {
    try {
      await publicClient.post("/mail/send", sendEmailInfo);
    } catch (err) {
      throw this.handleError(err);
    }
  }

  /**
   * 에러 처리
   */
  private handleError(err: any): Error {
    if (err.response?.data?.message) {
      return new Error(err.response.data.message);
    }
    if (err.message) {
      return new Error(err.message);
    }
    return new Error("이메일 발송 실패");
  }
}

export const mailAPI = new MailAPI();
